// extracted by mini-css-extract-plugin
export default {"tutorialBG":"TutorialStyles_tutorialBG__FtIC7","show":"TutorialStyles_show__ZX3bn","tutorial":"TutorialStyles_tutorial__oX-q0","skipCount":"TutorialStyles_skipCount__89nGO"};